<template>
  <div>
    <el-row>
      <el-col :span="24">
        <Head>
          <template v-slot:title>
            <span style="margin-left:30%;">高端人才审核</span>
          </template>
        </Head>
      </el-col>
    </el-row>
    <el-row class="row-top" type="flex" justify="center">
      <el-col :span="18">
        <bind-list2 v-if="isShow" @statusFun="getStatus" :genre="genre"></bind-list2>
        <advancedDetails v-else @statusFun="getStatus" :item="itemData"></advancedDetails>
      </el-col>
    </el-row>

  </div>
</template>
<script>
import Head from '@/components/header/head.vue';
import bindList2 from '@/components/audit/audit_list2.vue';
import advancedDetails from '@/views/advanced/advancedDetails.vue';

export default {
  data() {
    return {
      isShow: true,
      genre: true,
      itemData: []
    }
  },
  methods: {
    getStatus(isShow, itemData) {
      // console.log(isShow,itemData)
      this.isShow = isShow
      if (itemData) {
        this.itemData = itemData
      }
    }
  },
  components: {
    Head,
    bindList2,
    advancedDetails

  }
}
</script>
<style lang="less" scoped>

</style>
